import { render, staticRenderFns } from "./shebeipeizhi.vue?vue&type=template&id=729d12bb&scoped=true&"
import script from "./shebeipeizhi.vue?vue&type=script&lang=js&"
export * from "./shebeipeizhi.vue?vue&type=script&lang=js&"
import style0 from "./shebeipeizhi.vue?vue&type=style&index=0&id=729d12bb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729d12bb",
  null
  
)

export default component.exports